import T from '../Helpers/translate';
import { numberFormat } from 'App/babel/components/Filters/Currencies';
import UserDefinedObjectType from 'App/resources/Model/UserDefinedObjectType';

type GenerateSubtitleOptions = {
	type?: string;
	total: number;
	entityName?: string;
	listTitle?: string;
	formatTotal?: (total: number) => string;
	isReport?: boolean;
	hideSubtitle?: boolean;
	userDefinedObjects: UserDefinedObjectType[];
};

const generateSubtitle = (options: GenerateSubtitleOptions) => {
	const {
		type,
		total,
		entityName,
		listTitle,
		formatTotal,
		isReport = false,
		hideSubtitle = false,
		userDefinedObjects
	} = options;

	if (isReport || hideSubtitle) {
		return null;
	}

	if (formatTotal) {
		const totalString = formatTotal(total);

		if (totalString) {
			return totalString.toString();
		}
	}

	if (type?.includes('userDefinedObject')) {
		const udoId = parseInt(type.replace('userDefinedObject', ''));
		return `${numberFormat(total)} ${userDefinedObjects.find(x => x.id === udoId)?.name.toLowerCase() ?? ''}`;
	}

	const fallbackName = T(entityName || listTitle || '').toLowerCase();
	return `${numberFormat(total)} ${fallbackName}`;
};

export default generateSubtitle;
